import React from "react";
import Typography from '@mui/joy/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { Button, Menu, MenuItem, Dropdown, MenuButton } from "@mui/joy";
import ReplayIcon from '@mui/icons-material/Replay';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { PlayArrow, ArrowBack, ArrowForward, ThumbUp, ThumbDown, MoreVert, SmartToy } from "@mui/icons-material";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import History from '../../components/History';

const TaskResultHeader = ({
  id,
  inputStatus,
  onDelete,
  onReplay,
  onContinue,
  onGoToPolicy,
  onGoToAgentChat,
  onBack,
  onExportJson,
  onExportExcel,
  onLike,
  onDislike,
  onAddToEvaluation,
  currentFeedback,
  isEvaluation,
}) => {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'stretch', sm: 'center' }}
      justifyContent="space-between"
      mb={2}
      spacing={{ xs: 2, sm: 0 }}
      sx={{ width: '100%', justifyContent: 'space-between', display: 'flex', flexDirection: 'row' }}
    >
      <Stack sx={{ width: { xs: '100%', sm: '100%', }, flexGrow: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: { xs: 'left', sm: 'flex-start' }, mb: 1 }}>
          <History />
        </Box>
        <Typography level="h2" sx={{ textAlign: { xs: 'left', sm: 'left' } }}>
          Task No. {id}
        </Typography>
      </Stack>
      <Stack
        direction="row"
        spacing={{ xs: 1, sm: 2 }}
        alignItems="center"
      >
        {inputStatus === "action required" && (
          <Button
            startDecorator={<PlayArrow />}
            variant="soft"
            color="neutral"
            onClick={onContinue}
            sx={{ minWidth: 0, px: { xs: 1, sm: 2 } }}
          >
            <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>Continue</Box>
          </Button>
        )}
        {!isEvaluation ? (
          <Dropdown>
            <MenuButton
              slots={{ root: Button }}
              slotProps={{ root: {
                startDecorator: <ThumbUp />,
                variant: currentFeedback?.type === "like" ? "solid" : "soft",
                color: "success",
                sx: { minWidth: 0, px: { xs: 1, sm: 2 } }
              }}}
            >
              <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>Like</Box>
            </MenuButton>
            <Menu>
              <MenuItem onClick={onLike}>Like Task</MenuItem>
              <MenuItem onClick={onAddToEvaluation}>Add to Evaluation</MenuItem>
            </Menu>
          </Dropdown>
        ) : (
          <Button
            startDecorator={<ThumbUp />}
            variant={currentFeedback?.type === "like" ? "solid" : "soft"}
            color="success"
            onClick={onLike}
            sx={{ minWidth: 0, px: { xs: 1, sm: 2 } }}
          >
            <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>Like</Box>
          </Button>
        )}
        <Button
          startDecorator={<ThumbDown />}
          variant={currentFeedback?.type === "dislike" ? "solid" : "soft"}
          color="danger"
          onClick={onDislike}
          sx={{ minWidth: 0, px: { xs: 1, sm: 2 } }}
        >
          <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>Dislike</Box>
        </Button>
        <Button
          startDecorator={<ArrowBack />}
          color="neutral"
          onClick={onBack}
          sx={{ minWidth: 0, px: { xs: 1, sm: 2 } }}
        >
          <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>Back To Table</Box>
        </Button>
        <Dropdown>
          <MenuButton
            slots={{ root: Button }}
            slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}
            sx={{ minWidth: 0, px: 1 }}
          >
            <MoreVert />
          </MenuButton>
          <Menu sx={{ zIndex: 10000 }}>
            <MenuItem onClick={onExportJson}>
              <FileDownloadIcon sx={{ mr: 1 }} /> Export as JSON
            </MenuItem>
            <MenuItem onClick={onExportExcel}>
              <FileDownloadIcon sx={{ mr: 1 }} /> Export as Excel
            </MenuItem>
            <MenuItem onClick={onGoToPolicy}>
              <ArrowForward sx={{ mr: 1 }} /> Go To Policy
            </MenuItem>
            <MenuItem onClick={onGoToAgentChat}>
              <SmartToy sx={{ mr: 1 }} /> Investigate with Agent
            </MenuItem>

            <MenuItem onClick={onReplay} sx={{ color: 'success.500' }}>
              <ReplayIcon sx={{ mr: 1 }} /> Re-run
            </MenuItem>
            <MenuItem onClick={onDelete} sx={{ color: 'danger.500' }}>
              <DeleteOutlineRoundedIcon sx={{ mr: 1 }} /> Archive
            </MenuItem>
          </Menu>
        </Dropdown>
      </Stack>
    </Stack>
  );
};

export default TaskResultHeader;
